import { Backdrop, Button, Icon } from "@deligoo/ui"
import clsx from "clsx"
import { memo, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { Link, useLocation } from "react-router-dom"

import { requestUserLogout } from "@/store/user"

import cls from "./Sidenav.module.scss"

type SidenavProps = {
  active: boolean
  handleClose: () => void
}

export const Sidenav = memo(({ active, handleClose }: SidenavProps) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const location = useLocation()

  useEffect(() => handleClose(), [handleClose, location])

  return (
    <>
      {active && <Backdrop onClick={handleClose} style={{ zIndex: 1500 }} />}

      <nav className={active ? cls.sidenavActive : cls.sidenav}>
        <div className={cls.header}>
          <Button
            size="small"
            variation="text"
            className="mr-6"
            onClick={handleClose}
            iconProps={{ name: "close", size: "small", color: "primary" }}
          />
          <Link to="/">
            <img src="/assets/images/deligoo.svg" alt="DeliGoo" />
          </Link>
        </div>

        <ul className={cls.list}>
          <li className={cls.item}>
            <Link to="/" className={cls.link}>
              <Icon name="dashboard" className={cls.icon} />
              <span className={cls.text}>{t("dashboard")}</span>
            </Link>
          </li>
          <li className={cls.item}>
            <Link to="/kurierzy" className={cls.link}>
              <Icon name="courier" className={cls.icon} />
              <span className={cls.text}>{t("couriers")}</span>
            </Link>
          </li>
          <li className={cls.item}>
            <Link to="/lokalizacje" className={cls.link}>
              <Icon name="marker" className={cls.icon} />
              <span className={cls.text}>{t("places")}</span>
            </Link>
          </li>
          <li className={cls.item}>
            <Link to="/platnosci" className={clsx(cls.link, "hide-mobile")}>
              <Icon name="bills" className={cls.icon} />
              <span className={cls.text}>{t("payments")}</span>
            </Link>
          </li>
        </ul>

        <div className={cls.footer}>
          <Link to="/" className={cls.secondaryLink} onClick={() => dispatch(requestUserLogout())}>
            <Icon name="short-arrow-left" className={cls.icon} />
            <span className={cls.text}>{t("logout")}</span>
          </Link>
        </div>
      </nav>
    </>
  )
})
